import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/groups')({
  loader: () => {
    throw redirect({ to: '/group/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
